export default "__VITE_ASSET__DIWpmMFl__"